var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelease(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4092_100204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 40C14.3283 40 9.36838 37.8929 5.71142 34.1421C2.05446 30.3914 0 25.3043 0 20C0 14.6957 2.05446 9.60859 5.71142 5.85786C9.36838 2.10714 14.3283 0 19.5 0C24.6717 0 29.6316 2.10714 33.2886 5.85786C36.9455 9.60859 39 14.6957 39 20C39 25.3043 36.9455 30.3914 33.2886 34.1421C29.6316 37.8929 24.6717 40 19.5 40ZM15.6 30L33.15 13L30.225 10L15.6 24L8.775 17L5.85 20L15.6 30Z",
    fill: "#00BF6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4092_100204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelease);
export default __webpack_public_path__ + "static/media/release.5199ab7c6923588b489918b63210f983.svg";
export { ForwardRef as ReactComponent };